import axios from 'axios'
import router from "@/router";

const request = axios.create({
    baseURL: process.env.VUE_APP_BASEURL,
    timeout: 30000
})

request.interceptors.request.use(config => {
    if (config.data instanceof FormData) {
        delete config.headers['Content-Type']
    } else {
        config.headers['Content-Type'] = 'application/json;charset=utf-8'
    }
    const user = JSON.parse(localStorage.getItem('xm-user') || '{}')
    if (user.token) {
        config.headers['authorization'] = `Bearer ${user.token}`
    }
    return config
}, error => Promise.reject(error))

request.interceptors.response.use(
    response => {
        let res = response.data
        if (typeof res === 'string') {
            res = res ? JSON.parse(res) : res
        }
        return res
    },
    error => {
        if (error.response && error.response.status === 401) {
            localStorage.removeItem('xm-user')
            router.push('/login')
        }
        return Promise.reject(error)
    }
)

export default request
